export enum OrderStatus {
  NEW = 'NEW',

  ACCEPTED = 'ACCEPTED',

  REJECTED = 'REJECTED',
}
